var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pl-10 mt-n8"},[_c('div',[_c('v-btn',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.callApi()}}},[_vm._v("Call")])],1),_c('div',{staticClass:"mt-5"},[_c('pre',[_vm._v(_vm._s(JSON.stringify(_vm.result, null, 2)))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }